import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingLabel: {
		id: 'jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label',
		defaultMessage: 'Loading',
		description: 'Screen reader message on load of more filter options',
	},
});
export default messages;
